var map = {
	".": "wbzr",
	"./": "wbzr",
	"./01_get_contract_allPosition": "IW/r",
	"./01_get_contract_allPosition.json": "IW/r",
	"./02_get_contract_allOrders": "y5ws",
	"./02_get_contract_allOrders.json": "y5ws",
	"./03_get_contract_balance": "smla",
	"./03_get_contract_balance.json": "smla",
	"./index": "wbzr",
	"./index.js": "wbzr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1eM";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/standard/api/trade ^.*$
// module id = f1eM
// module chunks = 3